"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundPathParams = void 0;
class InboundPathParams {
    constructor() {
    }
    static getAttributeTypeMap() {
        return InboundPathParams.attributeTypeMap;
    }
}
exports.InboundPathParams = InboundPathParams;
InboundPathParams.discriminator = undefined;
InboundPathParams.attributeTypeMap = [
    {
        "name": "appId",
        "baseName": "app_id",
        "type": "string",
        "format": ""
    },
    {
        "name": "inboundToken",
        "baseName": "inbound_token",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=InboundPathParams.js.map